var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{style:({ 'background-image': ("url(" + _vm.background + ")"),
            width: _vm.canvasWidth + 'px',
            height: _vm.canvasHeight + 'px' }),attrs:{"width":_vm._f("devicePixelRatio")(_vm.canvasWidth),"height":_vm._f("devicePixelRatio")(_vm.canvasHeight),"rows":_vm.rows,"cols":_vm.columns,"top":_vm.top,"left":_vm.left}})}
var staticRenderFns = []

export { render, staticRenderFns }